<template>
  <div class="initiate-call">
    <div class="header">
      <div
        class="left"
        v-if="AnonymousCallProvider.times && AnonymousCallProvider.times > 0"
      >
        今日剩餘 <span class="times">{{ AnonymousCallProvider.times }}</span> 次
      </div>
      <div class="left times-info" v-else >
        <el-popover
          placement="bottom-start"
          width="430"
          trigger="hover"
          popper-class="initiate-call-popover"
        >
          <div class="phone-info">
            <div class="info">花費200幣可獲得3次發起，一日只能續加一次</div>
            <button class="price" @click="addTimes()">
              购买
            </button>
          </div>
          <span slot="reference">
            今日次数已用完，购买次数
          </span>
        </el-popover>
      </div>
      <SettingVue></SettingVue>
    </div>
    <div class="content no-scrollbar">
      <button
        class="btn-call"
        type="button"
        @click="initiateCall()"
      >
        <img class="icon-call" src="./images/icon-call.png" alt="" />
        <span>尋找有緣人...</span>
      </button>
      <div class="description">
        看看哪位陪玩會先接通～<br />
        (撥打時為匿名，可選擇是否公開身份)
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SettingVue from './setting.vue';
import AnonymousCallProvider from './anonymousCall';

export default {
  name: 'InitiateCall',
  components: {
    SettingVue
  },
  props: {},
  data() {
    return {
      needSpending: 300,
      AnonymousCallProvider
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['accountInfo']),
    balance() {
      return this.accountInfo ? this.accountInfo.balance || 0 : 0;
    },
    isNotEnoughBalance() {
      return this.balance < 100;
    }
  },
  methods: {
    addTimes() {
      this.$emit('onAddTimes');
    },
    selectSex(sexType) {
      this.AnonymousCallProvider.setMatchGender(sexType);
    },
    toRecharge() {
      this.$router.push('/saving');
    },
    initiateCall() {
      this.$emit('onInitiateCall');
    }
  }
};
</script>
<style lang="scss" scoped>
.initiate-call {
  color: white;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  line-height: 1.5;
  position: relative;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-bottom: 80px;
    margin-top: 20px;
    flex: none;
    width: 100%;
    padding: 0 24px;
  }
  .left {
    color: rgba(255, 255, 255, 0.55);
    .times {
      color: #ffffff;
    }
    &.times-info {
      cursor: pointer;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: auto;
    height: 1px;
    overflow: auto;
  }
  .title {
    color: #ffffff;
    font-size: 33px;
    font-weight: 500;
    margin-bottom: 3px;
  }
  .description {
    color: rgba(255, 255, 255, 0.55);
    text-align: center;
    font-weight: 400;
    line-height: 1.6;
    margin-bottom: 38px;
  }
  .sex-image {
    width: auto;
    height: 140px;
    position: relative;
    object-fit: cover;
    margin-bottom: 40px;
  }
  .group {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 1197.19px;
    width: 166.58px;
    height: 58.72px;
    background: rgba(255, 255, 255, 0.07);
    // margin-bottom: 90px;
    .item {
      cursor: pointer;
      &.active {
        background: rgba(255, 255, 255, 0.14);
        border-radius: 50%;
      }
      &:hover {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
      }
      width: 49px;
      height: 49px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .btn-call {
    background: rgba(25, 203, 28, 1);
    border-radius: 1197.19px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 22px;
    padding: 12px 50px 12px 30px;
    color: white;
    flex: none;
    &.active {
      background: #19cb1c;
    }
    img {
      margin-right: 20px;
      width: 20px;
    }
  }
  .balance-info {
    color: rgba(255, 255, 255, 0.35);
    font-size: 13px;
  }
  .btn-recharge {
    border-radius: 1197.19px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.35);
    border-width: 1.2px;
    padding: 4px 2px 4px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.55);
    font-size: 13px;
    margin-top: 16px;
    flex: none;
    margin-bottom: 20px;
    .icon-right {
      width: 6px;
      height: 6px;
      margin: 0 4px;
    }
  }
}
</style>

<style lang="scss">
.initiate-call-popover {
  color: rgba(255, 255, 255, 0.77) !important;
  background: rgba(255, 255, 255, 0.07);
  border-radius: 8.39px;
  border: none;
  .phone-info {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.77);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .price {
      color: #111111;
      background: #ffcb46;
      border-radius: 1197.19px;
      padding: 3.6px 8.39px 3.6px 8.39px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
  .popper__arrow,
  .popper__arrow::after {
    border-bottom-color: rgba(255, 255, 255, 0.07) !important;
  }
}
</style>
